// noinspection JSUnusedGlobalSymbols,JSFileReferences
import SweetAlert2 from 'sweetalert2/dist/sweetalert2.min.js'

export default class Helper
{
	static unit = {
		millisecond     : 1000,
		second_in_day   : 86400,
		second_in_minute: 60,
		minute_in_hour  : 60,
		hour_in_day     : 24,
	}

	static string(value)
	{
		return typeof value === 'string' || typeof value === 'number' ? String(value) : ''
	}

	static escape_html(string)
	{
		return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;')
	}

	static confirm(message, process, denied = undefined)
	{
		SweetAlert2.fire({
			title            : message,
			showCancelButton : true,
			confirmButtonText: 'OK',
			cancelButtonText : 'キャンセル',
			showClass        : {
				popup: 'animate__animated animate__fadeIn animate__faster',
			},
		}).then(result =>
		{
			if(result.isConfirmed) process()
			else if(typeof denied === 'function') denied()
		})
	}

	static language()
	{
		return $('body').data('language')
	}

	static message(selector, parameter)
	{
		let message = $(selector).data('message')

		if(parameter instanceof Array)
		{
			for(const value of parameter) message = message.replace(/%s/, value)
		}

		return message
	}
}
